//TNS Code version 2.0
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  const orderSampleButtons = document.querySelectorAll('.buy_sample'); // Get all buttons with the class 'buy_sample'
  const cartCountElement = document.querySelector('#cart-count'); // Adjust selector as needed

  if (cartDrawer && orderSampleButtons.length > 0) {
    // Function to update the cart drawer and cart count
    function updateCartDrawerAndCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart data fetched:', cart); // Debugging log

          // Fetch the HTML for the cart drawer content using Shopify's AJAX API
          fetch('/cart?sections=cart-drawer,cart-icon-bubble')
            .then(response => response.json())
            .then(sectionData => {
              // Use the existing renderContents function from cart-drawer.js
              cartDrawer.renderContents({
                sections: {
                  'cart-drawer': sectionData['cart-drawer'] || '',
                  'cart-icon-bubble': sectionData['cart-icon-bubble'] || ''
                },
                id: cart.item_count // Pass the item count as the ID
              });
              console.log('Cart drawer contents updated using renderContents'); // Debugging log
              
              // Update the cart count
              if (cartCountElement) {
                cartCountElement.textContent = cart.item_count;
                console.log('Updated cart count:', cart.item_count); // Debugging log
              } else {
                console.error('Cart count element not found.');
              }

              // Open the cart drawer after updating it
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
                console.log('Cart drawer opened'); // Debugging log
              } else {
                console.error('Cart drawer open method not found.');
              }
            })
            .catch(error => {
              console.error('Error fetching cart sections:', error);
            });
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
    }

    // Function to add product to the cart and open the drawer
    function addToCartAndOpenDrawer(event) {
      event.preventDefault(); // Prevent the default link behavior

      const productId = event.currentTarget.getAttribute('data-product-id'); // Get product ID from clicked button
      console.log('Product ID:', productId); // Debugging log

      // Add the product to the cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: productId, quantity: 1 }] })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add product to cart');
        }
        return response.json();
      })
      .then(cartData => {
        console.log('Product added to cart:', cartData); // Debugging log
        // Update the cart drawer contents and cart count, then open the drawer
        updateCartDrawerAndCount();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }

    // Attach event listeners to all "Order a Sample" buttons
    orderSampleButtons.forEach(button => {
      button.addEventListener('click', addToCartAndOpenDrawer);
    });
  } else {
    console.error('Cart drawer or order sample buttons not found on the page.');
  }
});


/*
//TNS Code version 1.1
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  const orderSampleButton = document.querySelector('.buy_sample');
  const cartCountElement = document.querySelector('#cart-count'); // Adjust selector as needed

  if (cartDrawer && orderSampleButton) {
    // Function to update the cart drawer and cart count
    function updateCartDrawerAndCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart data fetched:', cart); // Debugging log

          // Fetch the HTML for the cart drawer content using Shopify's AJAX API
          fetch('/cart?sections=cart-drawer,cart-icon-bubble')
            .then(response => response.json())
            .then(sectionData => {
              // Use the existing renderContents function from cart-drawer.js
              cartDrawer.renderContents({
                sections: {
                  'cart-drawer': sectionData['cart-drawer'] || '',
                  'cart-icon-bubble': sectionData['cart-icon-bubble'] || ''
                },
                id: cart.item_count // Pass the item count as the ID
              });
              console.log('Cart drawer contents updated using renderContents'); // Debugging log
              
              // Update the cart count
              if (cartCountElement) {
                cartCountElement.textContent = cart.item_count;
                console.log('Updated cart count:', cart.item_count); // Debugging log
              } else {
                console.error('Cart count element not found.');
              }

              // Open the cart drawer after updating it
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
                console.log('Cart drawer opened'); // Debugging log
              } else {
                console.error('Cart drawer open method not found.');
              }
            })
            .catch(error => {
              console.error('Error fetching cart sections:', error);
            });
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
    }

    // Function to add product to the cart and open the drawer
    function addToCartAndOpenDrawer(event) {
      event.preventDefault(); // Prevent the default link behavior

      const productId = orderSampleButton.getAttribute('data-product-id');
      console.log('Product ID:', productId); // Debugging log

      // Add the product to the cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: productId, quantity: 1 }] })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add product to cart');
        }
        return response.json();
      })
      .then(cartData => {
        console.log('Product added to cart:', cartData); // Debugging log
        // Update the cart drawer contents and cart count, then open the drawer
        updateCartDrawerAndCount();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }

    // Attach event listener to the "Order a Sample" button
    orderSampleButton.addEventListener('click', addToCartAndOpenDrawer);
  } else {
    console.error('Cart drawer or order sample button not found on the page.');
  }
});
*/